/**
 * add dots in number more than 999. Example: 10500 becomes 10.500
 *
 * @param num
 * @returns {string}
 */
export default function addDotsInNumber(num)
{
  return Number(num).toLocaleString('nl-NL');
}
